import { createSlice } from '@reduxjs/toolkit';
import { DefaultOauth, DefaultRole } from '@src/types/common';
import { UserRole } from '@src/types/user';
import { UsersState } from '@src/views/userList/store/userList';
import {
  getCompaniesPreview,
  getUserDetail,
} from '@src/views/userList/store/userSidebarThunk';
import updateUserThunk from './userThunk';

interface CompaniesFromServer {
  createdAt: string;
  role: UserRole;
  company: {
    name: string;
  };
}

export interface Managers extends UsersState {
  createdAt: string;
  role: UserRole;
  companyName: string;
}

interface InitialState {
  loading: boolean;
  isModalOpen: boolean;
  isDeleteUserModalOpen: boolean;
  id: number;
  name: string;
  email: string;
  mobileNumber: string;
  role: DefaultRole;
  managers?: Managers[];
  oauth?: DefaultOauth[];
  test?: string;
}

const initialState: InitialState = {
  loading: false,
  isModalOpen: false,
  isDeleteUserModalOpen: false,
  id: 0,
  name: '',
  email: '',
  mobileNumber: '',
  role: 'user',
  managers: [],
  oauth: [],
  test: '',
};

const userDetailSlice = createSlice({
  name: 'userDetail',
  initialState,
  reducers: {
    openModal(state) {
      state.isModalOpen = !state.isModalOpen;
    },
    onChangeDeleteUserModal: (state) => {
      state.isDeleteUserModalOpen = !state.isDeleteUserModalOpen;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getUserDetail.fulfilled,
        (state, { payload }: { payload: InitialState }) => {
          state.loading = false;
          state.id = payload.id;
          state.name = payload.name;
          state.email = payload.email;
          state.mobileNumber = payload.mobileNumber;
          state.role = payload.role;
          state.oauth = payload.oauth;
        }
      )
      .addCase(getUserDetail.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getCompaniesPreview.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompaniesPreview.fulfilled, (state, { payload }) => {
        state.loading = false;
        const tmpCompanies = payload.map((element: CompaniesFromServer) => {
          return {
            companyName: element.company.name,
            createdAt: element.createdAt,
            role: element.role,
          };
        });
        state.managers = tmpCompanies;
      })
      .addCase(getCompaniesPreview.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateUserThunk.fulfilled, (state, { payload }) => {
        state.isModalOpen = false;
        state.name = payload.name;
        state.email = payload.email;
        state.role = payload.role;
      })
      .addCase(updateUserThunk.rejected, (_, { payload }) => {
        throw payload;
      });
  },
});

export const { openModal, onChangeDeleteUserModal } = userDetailSlice.actions;

export default userDetailSlice.reducer;
